package org.mackclan.chat

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.safeContentPadding
import androidx.compose.material3.Button
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.TextFieldValue
import io.ktor.client.*
import io.ktor.client.plugins.websocket.*
import io.ktor.websocket.*
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.launch
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import org.jetbrains.compose.ui.tooling.preview.Preview

@Serializable
data class Message(val content: String, val user: String)

@Composable
@Preview
fun App(client: HttpClient) {

    var messages: List<String> by remember { mutableStateOf(listOf()) }
    var input: TextFieldValue by remember { mutableStateOf(TextFieldValue("")) }
    var user: TextFieldValue by remember { mutableStateOf(TextFieldValue("Nate")) }

    val sendChannel = Channel<String>(Channel.UNLIMITED)

    LaunchedEffect(Unit) {
        try {
            client.webSocket(host = "chat.nmckenzie.org", path = "/chat") {
                launch {
                    for (messageContent in sendChannel) {
                        val message = Message(messageContent, user.text)
                        send(Frame.Text(Json.encodeToString(message)))
                    }
                }

                for (frame in incoming) {
                    if (frame is Frame.Text) {
                        messages = messages.plus(frame.readText())
                    }
                }
            }
        } catch (e: Exception) {
            messages = listOf("SERVER ERROR: ${e.message}")
        }
    }


    MaterialTheme {
        Column(
            modifier = Modifier
                .background(MaterialTheme.colorScheme.primaryContainer)
                .safeContentPadding()
                .fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            messages.forEach { json ->
                val message = Json.decodeFromString<Message>(json)
                ChatBubble(message, message.user == user.text)
            }

            Row {
                TextField(
                    value = input,
                    onValueChange = { newValue ->
                        input = newValue
                    }
                )
                Button(
                    onClick = {
                        sendChannel.trySend(input.text)
                        input = TextFieldValue("")
                    }
                ) {
                    Text("Send")
                }
            }

            TextField(
                value = user,
                onValueChange = { newValue ->
                    user = newValue
                }
            )

        }

    }
}
